import type {FC} from 'react'
import Picker from '@shared/components/base/inputs/Picker'
import {useFilterParams} from '@shared/hooks/useFilterParams'
import {useCustomTranslation} from '@shared/hooks/useCustomTranslation'
import {FILTER_WIDTH} from '@shared/constants/filters'

const AnomalyFilterByDetectionType: FC = () => {
  const [t] = useCustomTranslation('anomalies')
  const {values, setValue} = useFilterParams({detection_type: {default: 'All'}})

  return (
    <Picker
      label="Detection Type"
      placeholder="Detection Type"
      value={values.detection_type}
      onChange={(value) => setValue('detection_type', value)}
      // A fixed set of kinds: Picker filters its own list, nothing to page.
      options={[
        {id: 'All', name: t('anomaly_feedback_chat.all')},
        {id: 'step_signal', name: t('step_signal')},
        {id: 'value_based', name: t('value_based')},
      ]}
      clearable={false}
      // A fixed list of three: the search row is most of the popover and has
      // nothing to search.
      hideSearch
      size="small"
      // Wide enough for the longest value; without a width of its own it
      // collapsed in the header row until the value read as an ellipsis.
      minWidth={FILTER_WIDTH}
      maxWidth={FILTER_WIDTH}
      dataCy="anomaly-detection-type-filter"
    />
  )
}

export default AnomalyFilterByDetectionType
